export default {
  name: "checkbox",
  box: 16,
  svg: `<path d="M13.4999 4.99994V14.2499C13.4999 14.5815 13.3682 14.8994 13.1338 15.1338C12.8994 15.3682 12.5814 15.4999 12.2499 15.4999H3.74992C3.4184 15.4999 3.10045 15.3682 2.86603 15.1338C2.63161 14.8994 2.49992 14.5815 2.49992 14.2499V4.99994" stroke="#9A9AB0" stroke-miterlimit="10" stroke-linecap="square"/>
  <path d="M8.00008 7.00003V12.5" stroke="#9A9AB0" stroke-miterlimit="10" stroke-linecap="square"/>
  <path d="M5.5001 7.00003V12.5" stroke="#9A9AB0" stroke-miterlimit="10" stroke-linecap="square"/>
  <path d="M10.5 7.00003V12.5" stroke="#9A9AB0" stroke-miterlimit="10" stroke-linecap="square"/>
  <path d="M5.5001 3.5V1H10.5001V3.5" stroke="#9A9AB0" stroke-miterlimit="10" stroke-linecap="square"/>
  <path d="M15 3.49997H1" stroke="#9A9AB0" stroke-miterlimit="10" stroke-linecap="square"/>`,
};
